import { apiRequest } from './api';

const isObject = (value) => value !== null && typeof value === 'object' && !Array.isArray(value);
const isString = (value) => typeof value === 'string';
const solved = (value) => (value === null ? null : Number.isInteger(value) && value >= 0 ? value : null);

export function decodeCodingProfile(data) {
  if (!isObject(data) || !isString(data.leetcode) || !isString(data.codeforces) || !isString(data.codechef)) return null;
  return {
    leetcode: data.leetcode,
    codeforces: data.codeforces,
    codechef: data.codechef,
    promptCompleted: data.promptCompleted === true,
    leetcodeLocked: data.leetcodeLocked === true,
    codeforcesLocked: data.codeforcesLocked === true,
    codechefLocked: data.codechefLocked === true,
    leetcodeSolved: solved(data.leetcodeSolved),
    codeforcesSolved: solved(data.codeforcesSolved),
    codechefSolved: solved(data.codechefSolved),
    leetcodeError: isString(data.leetcodeError) ? data.leetcodeError : null,
    codeforcesError: isString(data.codeforcesError) ? data.codeforcesError : null,
    codechefError: isString(data.codechefError) ? data.codechefError : null,
    fetchedAt: isString(data.fetchedAt) ? data.fetchedAt : null,
  };
}

function decodeTrackerRow(item) {
  if (!isObject(item) || !isString(item.userId) || !isString(item.username) || !Number.isInteger(item.rank)) return null;
  if (!Number.isInteger(item.algoforgeSolved) || !Number.isInteger(item.totalSolved)) return null;
  return {
    rank: item.rank,
    userId: item.userId,
    username: item.username,
    leetcodeSolved: solved(item.leetcodeSolved),
    codeforcesSolved: solved(item.codeforcesSolved),
    codechefSolved: solved(item.codechefSolved),
    algoforgeSolved: item.algoforgeSolved,
    totalSolved: item.totalSolved,
    fetchedAt: isString(item.fetchedAt) ? item.fetchedAt : null,
  };
}

export function decodeTracker(data) {
  if (!isObject(data) || !Array.isArray(data.rows)) return null;
  const rows = data.rows.map(decodeTrackerRow);
  if (rows.some((row) => row === null)) return null;
  return { rows };
}

export const trackerApi = {
  list: () => apiRequest('/platform/tracker', {}, decodeTracker),
  mine: () => apiRequest('/platform/coding-profiles/me', {}, decodeCodingProfile),
  save: (body) => apiRequest('/platform/coding-profiles/me', { method: 'PUT', body }, decodeCodingProfile),
  skip: () => apiRequest('/platform/coding-profiles/skip', { method: 'POST' }, decodeCodingProfile),
};
